module.exports = __webpack_public_path__ + "img/ey.198b3155.png";